var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddContent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#003557",
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 60 60",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,39H5v20c0,0.6,0.4,1,1,1h17v-2H7V39z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,2h36v9c0,0.6,0.4,1,1,1h9v28h2V11c0-0.1,0-0.2-0.1-0.3v-0.1c-0.1-0.1-0.1-0.2-0.2-0.3l-10-10c-0.1-0.1-0.2-0.1-0.3-0.2 h-0.1C44.2,0.1,44.1,0,44,0H6C5.4,0,5,0.4,5,1v16h2V2z M45,3.4l6.6,6.6H45V3.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 5,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,35v-7.6l5.7-5.7c0.3-0.3,0.4-0.7,0.2-1.1C39.8,20.2,39.4,20,39,20H1c-0.6,0-1,0.4-1,1v14c0,0.6,0.4,1,1,1h32 C33.6,36,34,35.6,34,35z M32,27v7H2V22h34.6l-4.3,4.3C32.1,26.5,32,26.7,32,27z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59,44H22c-0.4,0-0.7,0.2-0.9,0.6c-0.2,0.4-0.1,0.8,0.1,1.1l4.8,5.7V59c0,0.6,0.4,1,1,1h32c0.6,0,1-0.4,1-1V45 C60,44.4,59.6,44,59,44z M58,58L58,58H28h-0.1v-7c0-0.2-0.1-0.4-0.2-0.6L24.1,46H58L58,58L58,58z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 25,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 25,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 29,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 49,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 49,
    width: 22,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 53,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38,
    y: 53,
    width: 18,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 22,
    width: 8,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 26,
    width: 10,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 30,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 34,
    width: 14,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 54,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 54,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 54,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 50,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 50,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 46,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 42,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 46,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 50,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 54,
    width: 2,
    height: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddContent);
export default __webpack_public_path__ + "static/media/add-content.04f53e82a3659b35ff232a831b6de194.svg";
export { ForwardRef as ReactComponent };